import { render, staticRenderFns } from "./fbaPallet.vue?vue&type=template&id=232d43a4&scoped=true&"
import script from "./fbaPallet.vue?vue&type=script&lang=js&"
export * from "./fbaPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d43a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('232d43a4')) {
      api.createRecord('232d43a4', component.options)
    } else {
      api.reload('232d43a4', component.options)
    }
    module.hot.accept("./fbaPallet.vue?vue&type=template&id=232d43a4&scoped=true&", function () {
      api.rerender('232d43a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Warehousing/fbaPallet.vue"
export default component.exports